
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import { getLocalProject } from "@/utils"; //类型
import { dispatchGetPlayerid } from "@/store/performance/actions";
import { readGetPlayerid } from "@/store/performance/getters";
export default class TestReport extends Vue {
  // 获取默认数据
  public localProject = Number(getLocalProject()); //得到本地的项目
  public form = {
    playerid_src: "",
    playerid_dst: "",
  };
  public get playData() {
    return readGetPlayerid(store);
  }
  public async subBtn(first, second) {
    await dispatchGetPlayerid(store, {
      project: this.localProject,
      playerid_src: Number(first),
      playerid_dst: Number(second),
    });
    if (JSON.stringify(this.playData) == "{}") {
      alert("暂无数据");
    } else {
      alert(this.playData);
    }
  }
}
